import { render, staticRenderFns } from "./production-info-tab.vue?vue&type=template&id=693b5532&scoped=true"
import script from "./production-info-tab.vue?vue&type=script&lang=js"
export * from "./production-info-tab.vue?vue&type=script&lang=js"
import style0 from "./production-info-tab.vue?vue&type=style&index=0&id=693b5532&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "693b5532",
  null
  
)

export default component.exports